import React from 'react';
import { motion } from 'motion/react';
import { BookOpen, Heart, ShieldCheck, Sparkles } from 'lucide-react';

export const JOURNEY_TEXT = {
  preface: {
    title: "90天禱告的前言/自序 — 福音的童話故事",
    content: [
      "很久很久以前，當日月星辰、河川海洋和樹木花朵都還沒出現的時候，有一位慈愛的國王名叫耶和華，他用溫柔卻有力量的聲音，藉著他所發出的話語創造了宇宙萬物。於是，光照亮世界，天地甦醒，大地長出綠油油的森林與繽紛燦爛的花園，各樣的動物開始唱歌跳舞。最後，國王用自己的雙手細心的造了人，讓他們住在他的國度裡，把他們當成王子公主一樣的愛著他們，他們也親暱地稱呼國王為天父。",
      "國王有一位心愛的獨生子，他的名字叫耶穌。他從起初就喜愛陪在國王身邊，陪他創造了世界，把國度的子民當作自己的家人一樣。當時每個人的心好單純好幸福，心裡的光如明亮晨星般閃耀動人。",
      "然而，國中有一位名叫路西弗的大臣，不知何時開始不滿國王的統治，甚至想推翻他的政權。他特別喜歡躲在黑暗的角落裡，心懷不軌的看著這些百姓。他不喜歡這份光與愛，甚至連自己的名字都不喜歡，於是改名叫撒旦。他最擅長在人的耳邊，用悄悄話煽動人心：「國王沒有那麼愛你吧？你其實沒有那麼需要他吧？」",
      "漸漸的，有人開始相信撒旦的謊言，選擇離開天父，想要自己做主。他們心裡的光慢慢暗淡，越來越多人開始自私自利、勾心鬥角、彼此傷害，帶來許多的眼淚和痛苦，人們變成好像流離失所、無依無靠的孤兒。",
      "國王看著他視如己出的子民陷入如此的困境，既傷心又難過，但他從來沒有放棄，並早已計劃好要拯救他的子民。祂差派王子耶穌離開皇宮，尋找離開王國那些飽受黑暗所苦的百姓中間。王子耶穌親自找尋那些傷心的人，陪他們一起哭，告訴他們天父的愛從來沒有離開他們。耶穌走進人們心中的幽暗之地，點亮一顆又一顆的心，他安慰擁抱哭泣的人，想帶他們重回溫暖光明的家園。",
      "撒旦卻詭計多端，想方設法讓王子像犯人一樣被釘在十字架上，好教他再也沒辦法幫助人。耶穌被釘死在十字架的時候，大家本以為黑暗戰勝光明。但其實不然，這竟是國王早就預備的奇妙計畫——讓王子用自己的生命，替所有人承擔黑暗與罪，因為他們所犯的罪，最終會導致滅亡。耶穌不捨他們的心被撒旦擄走，想修復他們跟天父破碎的關係，他願意用自己的命換每一個人的命，因為他知道天父有多麼愛他的兒女。",
      "當王子耶穌在十字架上嚥下最後一口氣時，大地劇烈震動，天空陰冷灰暗，好像世界都在為他的殞落而哀悼。但第三天的清晨，奇蹟發生了——王子耶穌復活了！國王派了有超能力的精靈--名叫聖靈，幫助耶穌戰勝死亡！他復活後便開啟了一道閃閃發光的門，讓迷失人們能夠從奇妙通道重返國王的懷抱。光再次照亮大地，比以前更溫暖、更明亮。",
      "從那天起，那些相信王子耶穌用自己的生命承擔了他們的黑暗與罪、並深深明白國王有多麼愛他們的人，都再度回到國王的光明國度，戴上國王耶和華賜給他們的冠冕，身穿皇族的衣袍，重新成為國王所愛的王子和公主，住在充滿歡笑、盼望和永恆的美好國度，永永遠遠與愛他們的天父在一起，再也不分離。"
    ]
  },
  concepts: [
    {
      icon: <Sparkles className="text-amber-500" />,
      title: "獨特的創造",
      text: "每個孩子都是上帝獨特的創造，有屬於自己的能力、天賦、個性、氣質、命定和獨特的使命。"
    },
    {
      icon: <ShieldCheck className="text-blue-500" />,
      title: "上帝的產業",
      text: "孩子是耶和華所賜的產業。上帝把教養孩子的權柄交給我們，我們有責任帶領他們走當行的道。"
    },
    {
      icon: <Heart className="text-rose-500" />,
      title: "孩子的牧羊人",
      text: "父母是孩子的牧羊人，也就是引導者，並不是要控制他們的生命。我們會用話語和生命來建造他們。"
    }
  ],
  questions: [
    "透過這九十天的禱告，我期待自己教養孩子方面有什麼樣不同的改變？",
    "透過這九十天的禱告，我期待看見孩子在屬靈、在內心、在品格和行為上的成長有哪些？",
    "透過這九十天的禱告，我期待自己跟天父上帝的關係有什麼樣的改變？",
    "這90天不間斷的禱告是一個新習慣的養成。你會用什麼方法來提醒自己？你願意邀請哪些人來提醒你？"
  ]
};
